export default __webpack_public_path__ + "static/media/josh_raxlen.df2bf970.png";